<header *ngIf="(authenticationService.organisation$ | async)">
  <img src="{{ (authenticationService.organisation$ | async)?.logo }}" alt="{{ (authenticationService.organisation$ | async)?.display_name }}">
</header>
<fury-page-layout>
  <fury-page-layout-content @fadeInUp>
    <fury-container *ngIf="webformService.normalForm">
      <form [formGroup]="webformService.normalForm">
        <div fxLayout="row" fxLayoutGap="36px">
          <div fxFlex="100" fxFlex.gt-sm="80" fxLayout="column">
            <ng-container *ngIf="!formSubmitting && !formSubmitErrorSubmitted">
              <h1>Overzicht van uw melding</h1>
              <p>Hieronder vindt u een overzicht van uw melding zodat u deze nogmaals kan controleren.</p>
              <div class="grey-block">
                <div class="grey-block-header">
                  <h2>Details van uw melding</h2>
                  <button mat-flat-button (click)="editForm('melding')">
                    <mat-icon>create</mat-icon>
                    Deze gegevens wijzigen
                  </button>
                </div>
                <div fxLayout="column" fxLayout.gt-sm="row">
                  <div fxFlex.gt-sm="33">Hoofdcategorie:</div>
                  <div fxFlex.gt-sm="67">{{ getTextValue('headCategories', webformService.normalForm.controls.head_category_id.value) }}</div>
                </div>
                <div fxLayout="column" fxLayout.gt-sm="row" *ngIf="webformService.normalForm.controls.sub_category_id.value">
                  <div fxFlex.gt-sm="33">Subcategorie:</div>
                  <div fxFlex.gt-sm="67">{{ getTextValue('subCategories', webformService.normalForm.controls.sub_category_id.value) }}</div>
                </div>
                <div fxLayout="column" fxLayout.gt-sm="row">
                  <div fxFlex.gt-sm="33">Toelichting van uw melding:</div>
                  <div fxFlex.gt-sm="67">{{ webformService.normalForm.controls.description.value }}</div>
                </div>
                <div fxLayout="column" fxLayout.gt-sm="column">
                  <div>Foto's of bestanden van uw overlast:</div>
                  <div #attachmentsPlaceholder></div>
                </div>
              </div>
              <div class="grey-block">
                <div class="grey-block-header">
                  <h2>Locatie wan uw melding</h2>
                  <button mat-flat-button (click)="editForm('melding-locatie')">
                    <mat-icon>create</mat-icon>
                    Deze gegevens wijzigen
                  </button>
                </div>
                <div fxLayout="column" fxLayout.gt-sm="row">
                  <div fxFlex.gt-sm="33">Locatie:</div>
                  <div fxFlex.gt-sm="67">{{ webformService.normalForm.controls.report_location.value }}</div>
                </div>
                <div *ngIf="webformService.normalForm.controls.report_location_description.value" fxLayout="column" fxLayout.gt-sm="row">
                  <div fxFlex.gt-sm="33">Toelichting locatie overlast:</div>
                  <div fxFlex.gt-sm="67">{{ webformService.normalForm.controls.report_location_description.value }}</div>
                </div>
              </div>
              <div class="grey-block">
                <div class="grey-block-header">
                  <h2>Uw contact gegevens</h2>
                  <button mat-flat-button (click)="editForm('melder')">
                    <mat-icon>create</mat-icon>
                    Deze gegevens wijzigen
                  </button>
                </div>
                <ng-container *ngIf="webformService.normalForm.controls.reporter_anonymous.value === false">
                  <div fxLayout="column" fxLayout.gt-sm="row">
                    <div fxFlex.gt-sm="33">Aanhef:</div>
                    <div fxFlex.gt-sm="67">{{ webformService.normalForm.controls.reporter_prefix.value }}</div>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row">
                    <div fxFlex.gt-sm="33">Voorletters:</div>
                    <div fxFlex.gt-sm="67">{{ webformService.normalForm.controls.reporter_initials.value }}</div>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row">
                    <div fxFlex.gt-sm="33">Achternaam:</div>
                    <div fxFlex.gt-sm="67">{{ webformService.normalForm.controls.reporter_lastname.value }}</div>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row">
                    <div fxFlex.gt-sm="33">Woonadres:</div>
                    <div fxFlex.gt-sm="67">{{ webformService.normalForm.controls.reporter_location.value }}</div>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row">
                    <div fxFlex.gt-sm="33">E-mail:</div>
                    <div fxFlex.gt-sm="67">{{ webformService.normalForm.controls.reporter_email.value }}</div>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row">
                    <div fxFlex.gt-sm="33">Telefoonnummer:</div>
                    <div fxFlex.gt-sm="67">{{ webformService.normalForm.controls.reporter_phone.value }}</div>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row">
                    <div fxFlex.gt-sm="33">Notificatie ontvangen:</div>
                    <div fxFlex.gt-sm="67">{{ webformService.normalForm.controls.reporter_notify.value ? 'Ja' : 'Nee' }}</div>
                  </div>
                </ng-container>
                <ng-container *ngIf="webformService.normalForm.controls.reporter_anonymous.value === true">
                  Verstuur overlast anoniem
                </ng-container>
              </div>
            </ng-container>
            <div *ngIf="formSubmitting" class="form-loading-overlay">
              Uw melding wordt op dit moment verwerkt, een moment geduld aub ...
              <div class="progress">
                <div class="progress-bar" [style.width]="uploadProgress + '%'"></div>
              </div>
            </div>
            <div *ngIf="formSubmitError" class="form-loading-error">
              <p>Er is een fout opgetreden bij het maken van een melding. Verstuur ons de foutgegevens en wij gaan ermee aan de slag.</p>
              <br>
              <p>De gegevens van uw rapportage hebben wij ontvangen en zullen nogmaals de melding aanmaken met de door u aangeleverde gegevens. Dit wordt zo
                snel mogelijk verwerkt.</p>
            </div>
            <div *ngIf="formSubmitErrorSubmitted" class="form-loading-info">
              <p>Wij hebben uw gegevens in goede orde ontvangen en zullen uw melding zo spoedig opnieuw indienen.</p>
            </div>
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="16px" fxLayoutAlign.gt-sm="32px" *ngIf="!formSubmitting && !formSubmitErrorSubmitted">
              <button color="secondary" fxFlex="100" fxFlex.gt-sm="50" mat-button routerLink="/" type="button">
                Annuleer melding
                <mat-icon>cancel</mat-icon>
              </button>
              <button *ngIf="!formSubmitError" type="button" (click)="submit()" color="primary" fxFlex="100" fxFlex.gt-sm="50" mat-button>
                Verstuur melding
                <mat-icon>play_circle_outline</mat-icon>
              </button>
              <button *ngIf="formSubmitError" type="button" (click)="failedReport()" color="primary" fxFlex="100" fxFlex.gt-sm="50" mat-button>
                Verstuur melding
                <mat-icon>play_circle_outline</mat-icon>
              </button>
            </div>
          </div>
          <div class="steps-container" fxFlex.gt-sm="250px" fxHide fxLayout="row" fxLayoutAlign="flex-end" fxShow.gt-sm>
            <ul class="steps">
              <li class="step">Uw melding</li>
              <li class="step">Locatie van uw melding</li>
              <li class="step">Uw contact gegevens</li>
              <li class="step active">Controle melding</li>
              <li class="step">Ondertekenen</li>
            </ul>
          </div>
        </div>
      </form>
    </fury-container>
  </fury-page-layout-content>
</fury-page-layout>
